import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { NgxSpinnerService } from 'ngx-spinner';
import { Messages, QuestionnaireProcessStep } from 'src/app/common/enums';
import { SetSkipEmploymentHistoryRequest } from 'src/app/contracts/requests/worker-form/set-skip-employment-history-request';
import { WorkerFormService } from 'src/app/data/worker-form.service';
import { WorkerService } from 'src/app/data/worker.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';

@Component({
    selector: 'app-employment-history-step',
    templateUrl: './employment-history-step.component.html',
    styleUrls: ['./employment-history-step.component.scss'],
    standalone: false
})
export class EmploymentHistoryStepComponent implements OnInit {
  @Input() workerId: number;
  @Input() workerFormId: number;
  @Input() isLoggedUserProfile: boolean;
  @Input() stepper: MatStepper;

  isNextButtonDisabled: boolean = false;
  workerFormApproved: boolean = false;
  setSkipEmploymentHistoryChxValue: boolean = false;

  constructor(
    private workerFormService: WorkerFormService,
    private workerService: WorkerService,
    private spinner: NgxSpinnerService,
    private snackbarService: SnackBarService,
  ) {}

  ngOnInit(): void {
    this.stepper.selectionChange.subscribe((sc) => {
      if (sc.selectedStep.label as any as QuestionnaireProcessStep !== QuestionnaireProcessStep.EmploymentHistory){
        return;
      }

      this.workerService.getEmploymentHistorySkipInformation(this.workerId).subscribe({
        next: (res) => {
          if (res.WorkerFormApproved) {
            this.isNextButtonDisabled = false;
            this.workerFormApproved = res.WorkerFormApproved;
          } else {
            this.setSkipEmploymentHistoryChxValue = res.SkipEmploymentHistory;
            this.isNextButtonDisabled = !this.setSkipEmploymentHistoryChxValue && !res.AnyEmploymentHistoryEntry;
          }
        },
        error: (error: HttpErrorResponse) => {
          this.snackbarService.openErrorSnackBar(error.error);
        },
      });
    });
  }

  submitAndContinue() {
    if (this.isNextButtonDisabled) {
      return;
    }

    if (this.workerFormApproved) {
      this.stepper.next();
      return;
    }

    this.spinner.show();

    let req: SetSkipEmploymentHistoryRequest = {
      SkipEmploymentHistory: this.setSkipEmploymentHistoryChxValue,
    };
    
    this.workerFormService.setSkipEmploymentHistory(this.workerFormId, req).subscribe({
      next: () => {
        this.stepper.next();
      },
      error: (error: HttpErrorResponse) => {
        this.snackbarService.openErrorSnackBar(error.error);
      },
      complete: () => this.spinner.hide(),
    });
  }

  onEmploymentHistoryChanged(event: any) {
    this.setSkipEmploymentHistoryChxValue = event.chxValue;
    this.isNextButtonDisabled = !event.chxValue && !event.anyEmploymentHistoryEntry;
  }
}
